import { render, staticRenderFns } from "./userquestion.vue?vue&type=template&id=5c934e0a&scoped=true"
import script from "./userquestion.vue?vue&type=script&lang=js"
export * from "./userquestion.vue?vue&type=script&lang=js"
import style0 from "./userquestion.vue?vue&type=style&index=0&id=5c934e0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c934e0a",
  null
  
)

export default component.exports